const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Creativo
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo',
    name: 'creativo-stamps',
    component: ProductList,
    props: {
      title: 'Set de tampons alphabet Creativo',
      description:
        "Personnalise tes créations ultra facilement avec le set de tampons alphabet Creativo ! <br/> Avec ses lettres cursives, la police d'écriture Creativo est à la fois simple et élégante.",
      tags: ['set-tampon-alphabet-creativo'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/creativo/set-complet-creativo.jpg'),
          name: 'Creativo',
          variant: 'Set complet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/set-complet-creativo',
          highlight: true,
        },
        {
          src: require('../../../public/img/materiel-creatif/creativo/creativo-majuscules.jpg'),
          name: 'Creativo',
          variant: 'Jeu de majuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/majuscules-creativo',
        },
        {
          src: require('../../../public/img/materiel-creatif/creativo/creativo-minuscules.jpg'),
          name: 'Creativo',
          variant: 'Jeu de minuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/minuscules-creativo',
        },
        {
          src: require('../../../public/img/materiel-creatif/creativo/creativo-speciaux.jpg'),
          name: 'Creativo',
          variant: 'Caractères spéciaux & Chiffres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/speciaux-chiffres-creativo',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/set-complet-creativo',
    name: 'full-set-creativo',
    component: () =>
      import('../../pages/products/creative/Creativo/FullSet'),
    props: {
      src: require('../../../public/img/materiel-creatif/creativo/set-complet-creativo.jpg'),
      type: 'Set complet Creativo',
      hiddenType: 'creativo-stamps',
      description:
        'Un set complet se compose d’1 jeu de majuscules, 1 jeu de minuscules et 1 jeu de caractères spéciaux et chiffres.<br />Entre 110 et 125 caractères accompagnés de leurs plateaux de rangement.<br />Plusieurs lettres sont déjà en double mais n’hésite pas à doubler tout le jeu de minuscules et/ou majuscules pour obtenir un set ultra complet.<br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-creativo'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/majuscules-creativo',
    name: 'uppercase-creativo',
    component: () =>
      import('../../pages/products/creative/Creativo/Uppercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/creativo/creativo-majuscules.jpg'),
      type: 'Jeu de majuscules Creativo',
      hiddenType: 'creativo-stamps',
      description:
        'Un jeu de majuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-creativo'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/minuscules-creativo',
    name: 'lowercase-creativo',
    component: () =>
      import('../../pages/products/creative/Creativo/Lowercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/creativo/creativo-minuscules.jpg'),
      type: 'Jeu de minuscules Creativo',
      hiddenType: 'creativo-stamps',
      description:
        "Un jeu de minuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet-creativo'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo/speciaux-chiffres-creativo',
    name: 'specials-numbers-creativo',
    component: () =>
      import('../../pages/products/creative/Creativo/Special'),
    props: {
      src: require('../../../public/img/materiel-creatif/creativo/creativo-speciaux.jpg'),
      type: 'Caractères spéciaux et chiffres Creativo',
      hiddenType: 'creativo-stamps',
      description:
        'Un jeu de caractères spéciaux et chiffres comporte : 11 caractères accentués, 11 éléments de ponctuation, 2x les chiffres de 0 à 9 et même un petit cœur. <br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-creativo'],
    },
  },
];
